import { render, staticRenderFns } from "./fail-content.vue?vue&type=template&id=7638e2c6&scoped=true"
import script from "./fail-content.vue?vue&type=script&lang=js"
export * from "./fail-content.vue?vue&type=script&lang=js"
import style0 from "./fail-content.vue?vue&type=style&index=0&id=7638e2c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638e2c6",
  null
  
)

export default component.exports